import { type ReactNode } from "react";

// Canonical QBO status pill (S43): the day-close panel's soft-fill + inset-ring pill language,
// shared by every posting-status surface (modals, reports, events tab, posting log) so the
// vocabulary reads identically everywhere. `pillClass` supplies the colour family (fill + text +
// ring, light and dark) — see Pipeline/connectorVerdict.ts and the tenant's
// QuickBooks/dayCloseStatusStyles.ts; this component owns only the pill shape.
export function StatusPill({ pillClass, title, children }: StatusPillProps): ReactNode {
    return (
        <span
            className={`inline-flex items-center whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium ${pillClass}`}
            title={title ?? undefined}
        >
            {children}
        </span>
    );
}

export interface StatusPillProps {
    pillClass: string;
    /** Tooltip — typically the verdict reason; absent → no title attribute. */
    title?: string | null;
    children: ReactNode;
}
